<template>
  <div :class="'activitySkinColor'+ skinNum +'  activeDetail' + num + '  activeBackground' + numBackg">
  <!-- <div class="activeDetail"> -->
    <div class="activeDetail_banner" ref="activeDetail_bannerRef">
      <img :src="form.bannerUrl" alt="">
      <el-button 
        class="sigUp" 
        @click="signUpInfo" 
        v-if="form.status==='COLLECT'&&!isSignStatus"
      >我要报名</el-button>
      <el-button 
        class="sigUp" 
        @click="uploadWorks" 
        v-if="form.status==='COLLECT'&&isSignStatus">上传作品</el-button>
    </div>
    <div :class="isScroll?'activeDetail_nap fixedClass':'activeDetail_nap'" ref="signBtn">
      <div class="activeDetail_napBox">
        <p
          :class="items.id == activeNums ?'activeDetail_napBoxP'+ skinNum:''"
          @click="getTabsActive(items.id)"
          v-for="(items,index) in activeTabs"
          :key="index"
          >{{items.names}}</p>
      </div>
    </div>

    <!-- 活动详情--大赛主页 -->
    <active-zhu-Detail ref="activeDetailsRefs"  v-show="activeNums == '00' && activeModel == '1'"></active-zhu-Detail>
    <!-- 活动详情--大赛主页2 -->
    <active-zhutwo-Detail ref="activeDetailsRefs2"  v-show="activeNums == '00' && activeModel == '2'"></active-zhutwo-Detail>
    <!-- 活动详情--大赛主页2 -->
    <active-zhuthree-Detail ref="activeDetailsRefs3"  v-show="activeNums == '00' && activeModel == '3'"></active-zhuthree-Detail>
    <!-- 活动详情--参赛指南 -->
    <active-nan-Detail ref="activeNanRefs"  v-show="activeNums == '20'"></active-nan-Detail>
    <!-- 活动详情--参赛作品 -->
    <active-works-Detail ref="activeWorksRefs"  v-show="activeNums == '30'"></active-works-Detail>
    <!-- 活动详情--获奖作品 -->
    <active-win-Detail ref="activeWinRefs"  v-show="activeNums == '40'"></active-win-Detail>
    <!-- 报名 -->
    <sign-up ref="signUpRefs" v-show="activeNums == '01'"></sign-up>
    <!-- 上传作品 -->
    <upload-works ref="uploadWorksRefs" v-show="activeNums == '02'"></upload-works>


  </div>
</template>

<script>
import signUp from './signUp'
import uploadWorks from './uploadWorks'
import activeZhuDetail from './activeZhuDetail'
import activeZhutwoDetail from './activeZhutwoDetail'
import activeZhuthreeDetail from './activeZhuthreeDetail'
import activeNanDetail from './activeNanDetail'
import activeWorksDetail from './activeWorksDetail'
import activeWinDetail from './activeWinDetail'
import {mapState, mapMutations} from "vuex";
import { getActivityDetail, isSign, isUploadWorks, getNewcurrent } from '../../../utils/interface';
export default {
  name: "activeDetail",
  data() {
    return {
      uuid:"",
      form:{},
      activeNums: '00',
      activeModel: '1',
      modelColor: '模板一',
      isSignStatus:false,
      activeTabs: [
        {
          id: '00',
          names:'大赛主页'
        },
        {
          id: '20',
          names:'参赛指南'
        },
        {
          id: '30',
          names:'参赛作品'
        },
        {
          id: '40',
          names:'获奖作品'
        },
      ],
      isScroll: false,
      num: '',
      skinNum:0,
      skinColor: "",
      bannerRefHeight: "",
    };
  },
  components: {
    signUp,
    uploadWorks,
    activeZhuDetail,
    activeNanDetail,
    activeWorksDetail,
    activeWinDetail,
    activeZhutwoDetail,
    activeZhuthreeDetail,
  },
  created(){
    this.uuid = this.$route.params.uuid;
    // 查询详情
    this.getActivityDetail();
    // 查询是否报名
    this.getIsSign();
  },
  computed: {
    ...mapState({
      isLogin: "isLogin",
    }),
  },
  mounted(){
    this.activeNums = window.sessionStorage.getItem("activeDetailsNums") ? window.sessionStorage.getItem("activeDetailsNums"): '00'
    setTimeout(()=>{
      this.getInitializeNum()
    },500)
    window.addEventListener('scroll', this.handleScroll, true)
    this.upLoadShow()
  },
  methods: {
    ...mapMutations(["isLoginVuex"]),
    // 模板切换
    checkoutModel(){
      if(this.modelColor == '模板一') {
        this.activeModel = '1';
        if(this.skinColor == "蓝色版"){
          this.skinNum = 0;
        } else if(this.skinColor == "紫色版"){
          this.skinNum = 1;
        } else if(this.skinColor == "绿色版"){
          this.skinNum = 2;
        }
        this.$refs.activeDetailsRefs.init(this.uuid);
      }else if(this.modelColor == '模板二') {
        this.activeModel = '2';
        this.num = '2';
        console.log('this.skinColor',this.skinColor );
        if(this.skinColor == "skin1"){
          this.skinNum = 0;
          this.numBackg = 0;
        } else if(this.skinColor == "skin2"){
          this.skinNum = 1;
          this.numBackg = 1;
        } else if(this.skinColor == "skin3"){
          this.skinNum = 2;
          this.numBackg = 2;
        }
        this.$refs.activeDetailsRefs2.init(this.uuid);
      }else if(this.modelColor == '模板三') {
        this.activeModel = '3';
        this.num = '3';
        if(this.skinColor == "skin1"){
          this.skinNum = 0;
          this.numBackg = 3;
        } else if(this.skinColor == "skin2"){
          this.skinNum = 1;
          this.numBackg = 4;
        } else if(this.skinColor == "skin3"){
          this.skinNum = 2;
          this.numBackg = 5;
        }
        this.$refs.activeDetailsRefs3.init(this.uuid);
      }
    },
    // 初始化数据
    getInitializeNum(){
      this.bannerRefHeight = this.$refs.activeDetail_bannerRef.offsetHeight
      this.$refs.activeNanRefs.init(this.uuid);
      this.$refs.activeWorksRefs.init(this.uuid,this.bannerRefHeight);
      this.$refs.activeWinRefs.init(this.uuid,this.bannerRefHeight);
      this.$refs.signUpRefs.init(this.uuid);
      this.$refs.uploadWorksRefs.init(this.uuid);
    },
    refreshPage(){
      this.activeNums = '00';
      sessionStorage.setItem('activeDetailsNums','00');
      this.$refs.activeDetailsRefs.init(this.uuid);
      this.getIsSign();
      this.upLoadShow();
    },
    // 滚动定位
    handleScroll() {
      this.$nextTick(() => {
          let bannerRefH = this.$refs.activeDetail_bannerRef.offsetHeight
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          if (scrollTop > bannerRefH) {
              this.isScroll = true
          } else {
              this.isScroll = false
          }
      })
    },
    // 查询详情
    getActivityDetail(){
      getActivityDetail({uuid:this.uuid}).then((res)=>{
        this.form = res;
        // 模板名称
        this.modelColor = this.form.templateName;
        this.skinColor = this.form.styleName;
        // 切换模板
        this.checkoutModel();
      });
    },
    getIsSign(){
      isSign({activityUuid:this.uuid}).then((res)=>{
        if(res.data&&res.data.length>0){
          this.isSignStatus = true;
        }
      });
    },
    // 上传作品
    uploadWorks(){
      if(this.$store.state.isLogin) {
        /*this.$refs.uploadWorksRefs.init(this.form.uuid);
        sessionStorage.setItem('activeDetailsNums','02');
        this.activeNums = sessionStorage.getItem('activeDetailsNums');
        this.scrollToTop()*/
        window.open(this.$url.buyerWeb+"/#/myActivity",'_target');
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    // 是否是山传作品
    upLoadShow(){
      let showUpload = sessionStorage.getItem('activeDetailsNums') == '02'
      if(showUpload) {
        let signBtn = this.$refs.signBtn;
        window.scrollTo({
            top: signBtn.offsetTop,
            behavior: "smooth",
        });
      }
    },
    scrollToTop(){
      let signBtn = this.$refs.signBtn;
      window.scrollTo({
          top: signBtn.offsetTop - 80,
          behavior: "smooth",
      });
    },
    // 报名
    signUpInfo(){
      if(this.$store.state.isLogin) {
        getNewcurrent().then((data) => {
          // 1、设计师不显示
          // 2、个人用户要进行企业认证
          this.identity = data.identity;
          // if(this.identity === 'ANONYMOUS'){
          //   this.$confirm('请先进行实名认证!', '提示', {
          //     confirmButtonText: '去认证',
          //     cancelButtonText: '取消',
          //     type: 'warning'
          //   }).then(() => {
          //     window.sessionStorage.setItem("userServeId", "10");
          //     let routeData = this.$router.resolve({
          //       name: "userCenter",
          //       params: {
          //         userServeId: '10',
          //       },
          //     });
          //     window.open(routeData.href, "_target");
          //   });
          // }else{
            this.$refs.signUpRefs.init(this.form.uuid);
            sessionStorage.setItem('activeDetailsNums','01');
            this.activeNums = sessionStorage.getItem('activeDetailsNums');
            this.scrollToTop()
          // }
        });
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    // 点击切换
    getTabsActive(id){
      if(id == '00'){
        this.$refs.activeDetailsRefs.init(this.form.uuid);
      }else if(id == '20'){
        this.$refs.activeNanRefs.init(this.form.uuid);
      }else if(id == '30'){
        this.$refs.activeWorksRefs.init(this.form.uuid,this.bannerRefHeight);
      }else if(id == '40'){
        this.$refs.activeWinRefs.init(this.form.uuid,this.bannerRefHeight);
        //  this.$router.push('/activeList')
        //  return
      }
      this.activeNums = id;
      sessionStorage.setItem('activeDetailsNums',id);
    },
  },
};
</script>

<style scoped lang="less">
.activitySkinColor0{
  background: #C4DEFE;
  padding-bottom: 40px;
}
.activitySkinColor1{
  background: rgba(216, 217, 242, 1);
  padding-bottom: 40px;
}
.activitySkinColor2{
  background: rgba(236, 247, 236, 1);
  padding-bottom: 40px;
}
.activeDetail {
  //background: #C4DEFE;
  padding-bottom: 40px;
  .activeDetail_banner {

    width: 100%;
    // height: 646px;
    position: relative;
    img {
      height: 500px;
      width: 100%;
      display: block;
    }
    .sigUp {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 18px;
      width: 158px;
      height: 60px;
      background: #fff;
      box-shadow: 0px 7px 19px rgba(3, 62, 113, 0.66);
      border-radius: 30px;
      color: #2d50a1;
      font-weight: bold;
    }

  }
  .activeDetail_nap {
    height: 70px;
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 2px #d7d9e1a3;
    &.fixedClass {
      position: fixed;
      top: 80px;
      width: 100%;
      z-index: 99;
    }
    .activeDetail_napBox {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      /*.activeDetail_napBoxP {
        background: #B8D8FE;
        color: #124D92;
      }*/
      .activeDetail_napBoxP0 {
        background: #B8D8FE;
        color: #124D92;
      }
      .activeDetail_napBoxP1 {
        background: rgba(216, 217, 242, 1);
        color: #B0B1E5;
      }
      .activeDetail_napBoxP2 {
        background: rgba(236, 247, 236, 1);
        color: #61B45C;
      }
      p {
        color: #5D5D5D;
        width: 284px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
}
.activeBackground0 {
  background-image: url('../../../assets/activelistImg/background31.png');
  .activeDetail_nap {
    background: #fff;
  }
}
.activeBackground1 {
  background-image: url('../../../assets/activelistImg/background32.png');
  .activeDetail_nap {
    background: #fff;
  }
}
.activeBackground2 {
  background-image: url('../../../assets/activelistImg/background33.png');
  .activeDetail_nap {
    background: #fff;
  }
}
.activeDetail2 {
  background-size: 100%;
  padding-bottom: 40px;
  margin-top: -80px;
  .activeDetail_banner {
    width: 100%;
    position: relative;
    img {
      height: 100%;
      width: 100%;
      display: block;
    }
    .sigUp {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 18px;
      width: 158px;
      height: 60px;
      background: #fff;
      box-shadow: 0px 7px 19px rgba(3, 62, 113, 0.66);
      border-radius: 30px;
      color: #A70157;
      font-weight: bold;
    }

  }
  .activeDetail_nap {
    height: 70px;
    &.fixedClass {
      position: fixed;
      top: 80px;
      width: 100%;
      z-index: 99;
    }
    .activeDetail_napBox {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .activeDetail_napBoxP {
        // background: #B8D8FE;
        color: #A70157;
      }
      .activeDetail_napBoxP0 {
        background: #B8D8FE;
        color: #124D92;
      }
      .activeDetail_napBoxP1 {
        background: rgba(216, 217, 242, 1);
        color: #5c39fe;
      }
      .activeDetail_napBoxP2 {
        background: rgba(236, 247, 236, 1);
        color: #61B45C;
      }
      p {
        // color: #fff;
        width: 284px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
}
.activeBackground3 {
  background-image: url('../../../assets/activelistImg/background.png');
  .activeDetail_nap {
    background: #442cf4;
  }
}
.activeBackground4 {
  background-image: url('../../../assets/activelistImg/background22.png');
  .activeDetail_nap {
    background: #da8861;
  }
}
.activeBackground5 {
  background-image: url('../../../assets/activelistImg/background23.png');
  .activeDetail_nap {
    background: #6bd3c4;
  }
}
.activeDetail3 {
  // background-image: url('../../../assets/activelistImg/background.png');
  background-size: 100%;
  padding-bottom: 40px;
  .activeDetail_banner {
    width: 100%;
    position: relative;
    img {
      height: 100%;
      width: 100%;
      display: block;
    }
    .sigUp {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 30px;
      width: 228px;
      height: 81px;
      background: #efba3c;
      border-radius: 6px;
      color: #894408;
      border: 6px solid rgb(43, 20, 20);
      font-weight: bold;
    }

  }
  .activeDetail_nap {
    height: 70px;
    border-top: 6px solid rgb(43, 20, 20);
    border-bottom: 6px solid rgb(43, 20, 20);

    // box-shadow: 0px 0px 14px 2px #d7d9e1a3;
    &.fixedClass {
      position: fixed;
      top: 80px;
      width: 100%;
      z-index: 99;
    }
    .activeDetail_napBox {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .activeDetail_napBoxP {
        background: #f26606c2;
        color: #fff;
        border-left: 6px solid rgb(43, 20, 20);
        border-right: 6px solid rgb(43, 20, 20);
      }
      .activeDetail_napBoxP0 {
        background: #f26606c2;
        color: #fff;
        border-left: 6px solid rgb(43, 20, 20);
        border-right: 6px solid rgb(43, 20, 20);
      }
      .activeDetail_napBoxP1 {
        background: #f26606c2;
        color: #fff;
        border-left: 6px solid rgb(43, 20, 20);
        border-right: 6px solid rgb(43, 20, 20);
      }
      .activeDetail_napBoxP2 {
        background: #f26606c2;
        color: #fff;
        border-left: 6px solid rgb(43, 20, 20);
        border-right: 6px solid rgb(43, 20, 20);
      }
      p {
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        color: #fff;
        width: 284px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/activeDetail.vue